<template>
    <Multiselect id="ms_location" class="multiselect-locations multiselect-small" v-model="locationsSelected" mode="multiple"
        :close-on-select="false" :searchable="true" :create-option="false" :object="true" :options="locationsSelectable"
        :hideSelected="false" locale="de" fallback="en" @clear="clearedLocationMultiselect" placeholder="Standort(e) auswählen"
        @deselect="deselectedLocationMultiselect" @select="selectMultiselect" @close="reloadPage" />
</template>

<style>
.multiselect-locations {
    z-index: 120;
}
</style>


<script>

import Multiselect from '@vueform/multiselect';

import getLocations from "../composables/getLocations";

import { useLocationStore } from "../stores/LocationStore";
import { param } from 'jquery';

export default {

    setup() {
        const { locations, locations_error, loadLocations } = getLocations();
        loadLocations();

        let locationStore = useLocationStore();

        console.log('Locations', locations);
        return { locations, locations_error, locationStore: locationStore, };

    },
    name: "MultiselectLocations",
    components: {
        Multiselect,
    },
    props: {

    },
    data() {
        return {
            optionSelected: "",
            locationsSelected: [],
        }
    },
    mounted() {
        //console.log(this.locationStore.locations);
        this.locationsSelected = this.locationStore.locations;
        let url = new URL(window.location.href);
        var params = [];
        params = url.searchParams.get('view_locations');
        var selectedLocationIds = [];
        this.locationsSelected.forEach(element => {
            const view_locationId =
                element.value
                ;
            if (view_locationId != []) {
                selectedLocationIds.push(view_locationId);
            }
        });
        //console.log("this.locationsSelected: ", selectedLocationIds);
       // console.log("params: ", params);
        if (!params && selectedLocationIds.length > 0) {
            //console.log("empty params,");
            this.reloadPage();
        }
        else if (!params && selectedLocationIds.length == 0) {
            //console.log("do nothing"); 
        }
        else {
            // let symDifference = params.split(",").map(Number).filter(x => !selectedLocationIds.includes(x))
            //     .concat(selectedLocationIds.filter(x => !params.split(",").map(Number).includes(x)));
            // if (symDifference.length > 0) {
            //     console.log("array diff home url to multiselect", symDifference);
            //     //this.reloadPage();
            // }
            // else {
            //     //console.log("do nothing"); 
            // }
        }
    },
    watch: {
        locationsSelected(newValue, oldValue) {
            this.locationStore.locations = this.locationsSelected;
            //console.log(this.locationStore);
        }
    },
    computed: {
        locationsSelectable() {
            var items = [];
            if (this.locations) {
                this.locations.forEach(element => {
                    const location = {
                        value: element.id,
                        label: { en: element.name },

                    };
                    items.push(location);
                });
            }
            return items;
        },
    },
    methods: {
        clearedLocationMultiselect() {
            this.locationsSelected = []; //{ value: 0, label: 'all Locations' }
            let url = new URL(window.location.href);
            url.searchParams.delete('view_locations');
            window.location.href = url.toString();
        },
        deselectedLocationMultiselect() {
            if (this.locationsSelected.length == 0) {
                this.locationsSelected = [];//{ value: 0, label: 'all Locations' }
                let url = new URL(window.location.href);
                url.searchParams.delete('view_locations');
                window.location.href = url.toString();
            }
        },
        selectMultiselect() {
            if (this.locationsSelected.length > 0) {
                const allOptionSelected = this.locationsSelected.find((locationSelected) => locationSelected.value == []);
                if (allOptionSelected != null) {
                    this.locationsSelected = this.locationsSelected.filter((locationSelected) => locationSelected.value != 9999);
                }
            }
        },
        reloadPage() {
            var selectedLocationIds = [];
            this.locationsSelected.forEach(element => {
                const view_locationId =
                    element.value
                    ;
                if (view_locationId != 9999) {
                    selectedLocationIds.push(view_locationId);
                }
            });
            let url = new URL(window.location.href);
            console.log('view all', this.monitor);
            //url.searchParams.set('view_all', this.monitor ? '1' : '0');
            if (selectedLocationIds.length > 0) {
                url.searchParams.set('view_locations', selectedLocationIds);
            }
            window.location.href = url.toString();
        }
    }
}

</script>
<style scoped>
.multiselect-small {
    --ms-font-size: 0.8rem;
}
</style>>

